import axios from 'axios'
import apiUrl from '@/consts/api'

axios.interceptors.request.use(req => {
  document.getElementById('main-loader-api').style.display = 'block'
  return req
}, error => {
  document.getElementById('main-loader-api').style.display = 'none'
  return error.response
})

axios.interceptors.response.use(response => {
  document.getElementById('main-loader-api').style.display = 'none'
  return response
}, error => {
  document.getElementById('main-loader-api').style.display = 'none'
  return error.response
})

const methods = {
  get: async (endpoint, data = {}) => {
    const result = await axios({
      method: 'get',
      url: apiUrl + endpoint,
      data
    })
    return result
  },
  post: async (endpoint, data) => {
    const result = await axios({
      method: 'post',
      url: apiUrl + endpoint,
      data: data
    })

    return result
  }
}

export default methods
